import React,{useState} from 'react';
import apiService from '../../services/api';
import '../../pages/Survey/AddSurveyForm.css';
import { Box, Typography, CircularProgress } from '@mui/material';

const deleteImage= apiService.getBlobAssetUrl('Delete_graphic.svg');
const close= apiService.getBlobAssetUrl('close_popup.svg');
const DeleteConfirmationModal = ({ surveyName, onCancel, onConfirm, onClose,setSnackbarOpen, setSnackbarMessage }) => {
  const [isLoading, setIsLoading] = useState(false);
  const handleConfirm = async () => {
    setIsLoading(true);
    try {
      await onConfirm(); 
      console.log('survey deleted');
      setSnackbarMessage('Survey deleted successfully'); 
      setSnackbarOpen(true); 
    } catch (error) {
      setSnackbarMessage(`Failed to delete survey: ${error.message || 'Unknown error'}`); 
      setSnackbarOpen(true); 
    } finally {
      setIsLoading(false);
    }
  };
  return (
    <div className="add-survey-modal-overlay">
      <div id="survey-modal">
      <div id="delete-2">
      <div className="add-survey-delete-modal-header" id="survey-header">
        <h3 id="delete-5">Delete</h3>
        <button className="close-btn" onClick={onCancel}><img src={close} alt="close" className="close-img" id="edit-11" /></button>
                </div><br/><br/>
      <img src={deleteImage} alt="delete" className="delete-img" id="delete-3"/>
        
        <p id="delete-4">Are you sure you want to Delete the survey <span id="delete-6">"{surveyName}"?</span></p>

        <div className="add-survey-modal-actions">
          <button onClick={onCancel} id="delete-no">No</button>

          <button onClick={handleConfirm} id="delete-yes" disabled={isLoading}>
           {isLoading ? (
             <>
             <CircularProgress size={20} style={{ marginRight: '8px', color: 'white' }} />
              Deleting...
            </>
            ) : (
             'Yes'
            )}
          </button>
        </div>
      </div>
    </div>
    
    </div>
    
  );
};

export default DeleteConfirmationModal;
